/* Pochette cadeau offerte (2026-10-19) — voir snippets/uk-pochette.liquid.
   « Kit » = tout produit éligible (type « Plaque photo plexiglas » : kits et plaques avec cœur).
   1. Quand un kit éligible est ajouté au panier avec la case cochée, la pochette (0 €) est ajoutée sur sa propre ligne.
      On écoute l'événement « variant:add » du thème : il n'est émis qu'une fois le kit réellement ajouté
      (formulaire du thème, après validation du personnaliseur). Le kit et ses données ne sont jamais modifiés.
   2. Garde-fou à chaque changement du panier et à chaque chargement de page : au plus une pochette par kit
      éligible, aucune pochette sans kit. */
(function () {
  var C = window.ukPochette;
  if (!C || !C.variante || !C.type || !window.fetch) return;
  var racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var enCours = false;

  function estKit(l) { return (l.product_type || '').indexOf(C.type) !== -1; }
  function estPochette(l) { return l.variant_id === C.variante; }
  function somme(lignes) { return lignes.reduce(function (s, l) { return s + l.quantity; }, 0); }

  function publier(nom, donnees) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(nom, donnees || {}); } catch (e) {}
  }

  function rafraichir() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function envoyer(url, corps) {
    return fetch(racine + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(corps)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  /* Message dans la fenêtre « ajouté au panier » */
  function noter(ok) {
    var info = document.querySelector('cart-notification-drawer .quick-buy-drawer__info');
    if (!info) return;
    var p = document.createElement('p');
    p.className = 'uk-pochette-note' + (ok ? '' : ' uk-pochette-note--erreur');
    p.textContent = ok ? 'Pochette cadeau offerte ajoutée à votre panier.' : 'La pochette cadeau n’a pas pu être ajoutée. Écrivez-nous, nous la joindrons à votre commande.';
    var apres = info.querySelector('free-shipping-bar') || info.firstElementChild;
    if (apres && apres.nextSibling) info.insertBefore(p, apres.nextSibling); else info.appendChild(p);
  }

  /* 1. Ajout de la pochette après le kit */
  document.addEventListener('variant:add', function (ev) {
    var lignes = (ev.detail && ev.detail.items) || [];
    var kits = lignes.filter(estKit);
    if (!kits.length) return;
    var form = ev.target && ev.target.nodeType === 1 ? ev.target : null;
    var bloc = (form && form.querySelector('[data-uk-pochette-case]')) || document.querySelector('[data-uk-pochette-case]');
    if (!bloc || !bloc.checked) return;
    enCours = true;
    envoyer('cart/add.js', { items: [{ id: C.variante, quantity: kits.length, properties: { _pochette: 'offerte' } }] })
      .then(function () {
        noter(true);
        publier('uniko_pochette_ajoutee', { kit: kits[0].handle });
        return fetch(racine + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (panier) { enCours = false; return verifier(panier); })
      .then(rafraichir)
      .catch(function (e) { enCours = false; noter(false); if (window.console) console.warn('Pochette cadeau :', e); });
  });

  /* Case cochée ou décochée : mesure (événement personnalisé, lisible par un pixel personnalisé) */
  document.addEventListener('change', function (ev) {
    var c = ev.target;
    if (!c || !c.matches || !c.matches('[data-uk-pochette-case]')) return;
    publier('uniko_pochette_case', { cochee: c.checked });
  });

  /* 2. Garde-fou */
  function verifier(panier) {
    if (!panier || !panier.items) return Promise.resolve(false);
    var nbKits = somme(panier.items.filter(estKit));
    var poch = panier.items.filter(estPochette);
    var trop = somme(poch) - nbKits;
    if (trop <= 0) return Promise.resolve(false);
    var maj = {};
    poch.slice().reverse().forEach(function (l) {
      if (trop <= 0) return;
      var retire = Math.min(trop, l.quantity);
      maj[l.key] = l.quantity - retire;
      trop -= retire;
    });
    return envoyer('cart/update.js', { updates: maj }).then(function () { return true; });
  }

  function verifierEtRafraichir(panier) {
    if (enCours) return;
    var p = panier ? Promise.resolve(panier) : fetch(racine + 'cart.js').then(function (r) { return r.json(); });
    p.then(verifier).then(function (change) {
      if (!change) return;
      if (window.themeVariables && themeVariables.settings && themeVariables.settings.pageType === 'cart') window.location.reload();
      else rafraichir();
    }).catch(function () {});
  }

  document.addEventListener('cart:change', function (ev) {
    if (ev.detail && ev.detail.baseEvent === 'variant:add') return;
    verifierEtRafraichir(ev.detail && ev.detail.cart);
  });
  /* Au chargement : seulement si le panier contient plus de pochettes que de kits (calculé par le serveur) */
  if (C.verifier) verifierEtRafraichir();
})();
